// Module
var code = `  <div class="filters no-print">
    <span class="labelled-field">
      <label class="add-on">Mapping name</label>
      <input type="text" class="filter-value" ng-model="\$ctrl.filter.accountName">
    </span>
    <button
      type="button"
      class="btn"
      command-access="SynchronizeOracleHandoffMappings"
      ng-click="\$ctrl.synchronize()">
      Synchronize
    </button>
  </div>

  <div>
    <table ng-table="\$ctrl.tableConfig"  class="table gl-mappings__table">
      <tr ng-repeat="mapping in \$data">
        <td data-title="'Account code'" sortable="'accountFullCode'">{{mapping.accountFullCode}}</td>
        <td data-title="'Account name'" sortable="'accountName'" header-class="'col-name'">{{mapping.accountName}}</td>
        <td data-title="'Oracle account code'" class="centered-cell" header-class="'centered-cell'">
          <input
            type="text"
            ng-model="mapping.mappingCode"/>
        </td>
        <td data-title="'Oracle account name'" class="centered-cell" header-class="'centered-cell'">
          <input
            type="text"
            ng-model="mapping.mappingName"/>
        </td>
        <td class="centered-cell col-button">
          <button
            command-access="UpdateOracleHandoffMapping"
            type="button"
            class="btn btn-primary"
            ng-click="\$ctrl.save(mapping)">
            Save
          </button>
        </td>
      </tr>
    </table>
  </div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/bss/oracle-handoff-mapping/oralce-handoff-mapping.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;